import { FOLDERS, INPUT_TYPES, SETTING_ELEMENT_TYPE } from '../constants';
import { DateString } from './dateString';

const INPUT_TYPES_ENUM = Object.values(INPUT_TYPES).map(({ name }) => name);
const SETTING_TYPE_ENUM = Object.values(SETTING_ELEMENT_TYPE).map((value) => value);
export const FOLDERS_ENUM = Object.values(FOLDERS).map((value) => value);

type SettingInputValidation<T> = {
  type: 'required' | 'greaterThan' | 'lessThan' | 'lessThanOrEqual' | 'greaterThanOrEqual' | 'when' | 'range';
  message?: string;
  settingInput?: string;
  value?: T;
  notValue?: T;
  anySettingInputTruthy?: string[];
  min?: number;
  max?: number;
  then?: SettingInputValidation<unknown>[];
};

type SettingDefinition = {
  id: string;
  type: typeof INPUT_TYPES_ENUM[number];
  // An array means every condition must hold (AND).
  displayCondition?: DisplayCondition | DisplayCondition[];
  validations?: SettingInputValidation<any>[];
  label: string;
};

export type SubGroup = {
  settingDefinitions: SettingDefinition[];
};

type PrimarySetting = {
  defaultFilter: boolean;
  defaultSort: boolean;
  label: string;
  searchable: boolean;
  settingId: string;
  priority: string;
};

type Definition = {
  applicableForCrews: boolean;
  applicableForMembers: boolean;
  displayCondition?: DisplayCondition;
  creatable?: boolean;
  versions?: boolean;
  createSettingGroups?: Array<Definition>;
  deletable?: boolean;
  deleteInfo?: {
    headerText: string;
    buttonLabel: string;
  };
  description: string;
  descriptionMember: string;
  disabledSettingData?: {
    title: string;
    content: string;
    cta: {
      text: string;
      link: string;
    };
  };
  id: string;
  primarySettings?: Array<PrimarySetting>;
  reprocessWarning?: string;
  subGroups: SubGroup[];
  // Backend-driven settings' raw JSON uses this lowercase casing instead of `subGroups` — read
  // whichever is present (see SettingGroup.js's `subgroups || subGroups`).
  subgroups?: SubGroup[];
  title: string;
  titleMember: string;
  updateSettingGroups?: Array<Definition>;
};

export type Folder = typeof FOLDERS_ENUM[number];

export type Type = typeof SETTING_TYPE_ENUM[number];

type DisplayCondition = {
  settingInput?: string;
  value?: unknown;
  notValue?: unknown;
  anySettingInputTruthy?: string[];
  featureFlag?: string;
}

export type SettingDefinitionType = {
  definition: Definition;
  folder: Folder;
  type: Type;
  language?: 'en' | 'de';
};

export type TripleId = {
  userId?: number;
  validFrom?: DateString;
  validTo?: DateString;
};